export class CarRentalLocation {
  name!: string;
  latitude!: number;
  longitude!: number;
  sourceId!: number | string;
  type!: CarRentalLocationType;
}

export enum CarRentalLocationType {
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
}
